import { GET_CLIENT_TYPES } from '../actions/types';

const initialState = {
  list: []
};
// const initialState = [{ id: 1, name: 'Малий' }, { id: 2, name: 'Середній' }, { id: 3, name: 'Великий' }];

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CLIENT_TYPES: {
      return { ...state, ...{ list: action.clientTypesData } };
    }
    default:
      return state;
  }
}
